import Vue from 'vue';
import { Browser } from '../types/browser';

declare global {
  interface Navigator {
    brave?: any;
  }
  interface Window {
    safari?: any;
  }
}

/**
 * This plugin is a copy of vue-browser-detect-plugin.
 * https://github.com/ICJIA/vue-browser-detect-plugin/
 */

export default (_, inject) => {
  const browserVm = new Vue({
    data() {
      return {
        browser: {
          isOpera: false,
          isEdge: false,
          isFirefox: false,
          isSafari: false,
          isChrome: false,
          isChromeIOS: false,
          isIE: false,
          isIOS: false,
          isBrave: false,
          meta: {
            name: '',
            version: '',
            ua: '',
          },
        },
      };
    },
    created() {
      if (!process.client) return;

      const { userAgent } = navigator;

      this.browser.isOpera = userAgent.includes(' OPR/');
      this.browser.isEdge = /Edg/.test(userAgent);
      this.browser.isFirefox = /Firefox/.test(userAgent);
      this.browser.isSafari =
        /constructor/i.test(String(window.HTMLElement)) ||
        (function (p) {
          return p.toString() === '[object SafariRemoteNotification]';
        })(!window.safari || (window.safari && window.safari.pushNotification));
      this.browser.isChrome = /Google Inc/.test(navigator.vendor) && !this.browser.isEdge;
      this.browser.isChromeIOS = /CriOS/.test(userAgent);
      this.browser.isIE = !!(document as any).documentMode;
      this.browser.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
      this.browser.isBrave = typeof navigator.brave !== 'undefined';

      this.browser.meta = this.browserSpecs(userAgent);
      this.browser.meta.ua = userAgent;
    },
    methods: {
      browserSpecs(ua) {
        let tem,
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return { name: 'IE', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null) return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] };
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return { name: M[0], version: M[1] };
      },
    },
  }) as { browser: Browser };

  inject('browserDetect', browserVm.browser);
};
